import { ReactElement } from "react";

import Head from "next/head";

import { Link } from "@chakra-ui/next-js";

import { Product } from "@/__generated__/graphql";
import Register from "@/components/Register";
import InstantDatasetsLoginLayout from "@/layouts/InstantDatasetsLoginLayout";

function InstantDatasetsPage() {
  return (
    <>
      <Head>
        <title>Instant Datasets by Release</title>
        <meta content="Instant Datasets by Release" name="description" />
        <link href="/favicon.ico" rel="icon" />
      </Head>
      <Register product={Product.StandaloneDatasets} />
    </>
  );
}
export default InstantDatasetsPage;

InstantDatasetsPage.getLayout = (page: ReactElement) => {
  return (
    <InstantDatasetsLoginLayout
      secondaryAction={
        <>
          Have an account?{" "}
          <Link fontWeight="bold" href="/login">
            Sign in
          </Link>
        </>
      }
    >
      {page}
    </InstantDatasetsLoginLayout>
  );
};
